import React, { useCallback, useEffect, useState } from 'react'
import {
  Container,
  Divider,
  GridList,
  GridListTile,
  GridListTileBar,
  MenuItem,
  Select,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Media, ImageModal, useImageModal } from 'src/components/media'
import { useFetchCSV, useGridSize } from 'src/hooks'
import { searchCharactor } from 'src/util/entryHelper'

const useStyle = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1)
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  headerAnchor: {
    textAlign: 'right'
  }
}))

const ErrorComponent: React.VFC = () => <p>なんかエラーだった。</p>
const NoneResultsComponent: React.VFC = () => <div></div>

const Home: React.VFC = () => {
  const classes = useStyle()
  const gridProps = useGridSize()
  const imageModalControl = useImageModal()
  const [select, setSelect] = useState<keyof Motions>('EXモーション')

  const [motions, motionsErr] = useFetchCSV<Motions>('0')
  useEffect(() => {}, [select])

  const getImageGrid = useCallback(() => {
    if (motionsErr) {
      return <ErrorComponent />
    } else if (!motions) {
      return <NoneResultsComponent />
    } else {

      return (
        <GridList {...gridProps}>
          {motions?.body.filter((e) => e[select].startsWith('http'))
            .map((e) => (
              <GridListTile key={e['名前(50音順)']}>
                <div
                  onClick={() =>
                    imageModalControl.others.handleOpen(e[select])
                  }
                  style={{
                    backgroundColor: '#000',
                    width: '100%',
                    height: '100%'
                  }}
                >
                  <Media url={e[select]} objectFit="cover" />
                </div>
                <GridListTileBar
                  title={e['名前(50音順)']}
                  subtitle={
                    <a
                      href={e[select]}
                      target="_blank"
                      rel="noopner noreferrer"
                      style={{ color: 'white' }}
                    >
                      {e[select]}
                    </a>
                  }
                  actionIcon={
                    <img
                      src={searchCharactor(e['名前(50音順)'])?.image}
                      alt=""
                      style={{ width: 57, height: 64, objectFit: 'cover' }}
                    />
                  }
                />
              </GridListTile>
            ))}
        </GridList>
      )
    }
  }, [motions, motionsErr, gridProps, imageModalControl.others, select])

  return (
    <Container className={classes.root}>
      <ImageModal {...imageModalControl.props}>
        <Media url={imageModalControl.others.image} objectFit="contain" />
      </ImageModal>
      <header>
        <Typography variant="h4">各種モーション</Typography>
        <Typography variant="body2" className={classes.headerAnchor}>
          <a
            href="https://docs.google.com/spreadsheets/d/1yQN-8pYee_ycd1p4IUEd0YVR4s2Yg_CIWGf4x4YwgPc/edit#gid=0"
            target="_blank"
            rel="noopner noreferrer"
          >
            【ブルアカ】5chGIFまとめ保管庫【誰でも編集可】
          </a>
        </Typography>
      </header>
      <Divider className={classes.divider} />
      <div style={{ margin: 20 }}>
        <Select
          value={select}
          onChange={(e) => setSelect(e.target.value as (keyof Motions))}
        >
          {motions?.header
            .filter((e) => e !== '名前(50音順)')
            .filter((e) => e !== '←モーション枠の列追加自由に')
            .map((e) => (
              <MenuItem key={e} value={e}>
                {e}
              </MenuItem>
            ))}
        </Select>
      </div>
      {getImageGrid()}
    </Container>
  )
}

export default Home
